import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import SettlementCheckModel from "../../models/settlement-check";

export default class SettlementCheckRepository extends BaseRepository {
  static modelClass = SettlementCheckModel;
  modelName = "settlement-check";
}
